import { ImageOff } from 'lucide-react';
import { useEquipmentFileUrl } from '../hooks/useEquipment';

/** Thumbnail of a private library photo, loaded through a short-lived signed URL. */
export function PhotoThumb({ photoId, alt, className = 'h-9 w-12' }: { photoId: string | null; alt: string; className?: string }) {
  const { data: url } = useEquipmentFileUrl('photos', photoId);
  if (!photoId || !url) {
    return (
      <div className={`${className} rounded bg-muted flex items-center justify-center`}>
        {!photoId && <ImageOff className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />}
      </div>
    );
  }
  return <img src={url} alt={alt} className={`${className} rounded object-cover bg-muted`} loading="lazy" />;
}
